module.exports = __webpack_public_path__ + "../resources/img/Icon_Edit_Color.5c88bb6f.svg";